//자료실 상단 배너
import { NavLink, useLocation } from "react-router-dom";
import "./Tab.css";

export default function Tab() {
    const location = useLocation();
    const tabs = [
        {path: "/documents/student-council", name: "총학생회"},
        {path: "/documents/central-committee", name: "중앙운영위원회"},
        {path: "/documents/audit-committee", name: "감사위원회"},
        {path: "/documents/others", name: "기타"},
        {path: "/documents/delegate", name: "대의원 활동 인증서"}
    ];
    return (
            <div className="documents-chart">
                {tabs.map((tab) => (
                    <NavLink
                        key={tab.path}
                        to={tab.path}
                        className={({ isActive }) => {
                            if (tab.path === "/documents/student-council") {
                                return isActive || location.pathname === "/documents" ? "chart active" : "chart";
                            }
                            return isActive ? "chart active" : "chart";
                        }}
                    >
                        {tab.name}
                    </NavLink>
                ))}
            </div>
    );
}